import { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import * as VideoExpress from '@vonage/video-express';
import MuteAudioButton from 'components/MuteAudioButton';
import MuteVideoButton from 'components/MuteVideoButton';
import CombinedAudioButtonLivemeeting from 'components/CombinedAudioButtonLivemeeting';
// import SpeakerButton from 'components/SpeakerButton';
import SpeakerSelector from 'components/SpeakerSelector';
import RecordingButton from 'components/RecordingButton';
import LayoutButton from 'components/LayoutButton';
import MuteAll from 'components/MuteAllButton';
import ReactionsButton from 'components/ReactionsButton';
import ScreenSharingButton from 'components/ScreenSharingButton';
import EndCallButton from 'components/EndCallButton';
import VideoFilterButton from 'components/VideoFilterButton';
import styles from './styles';
import { useParams } from 'react-router';
import { useTheme } from '@material-ui/core';
import MoreOptionsButton from 'components/MoreOptionsButton';
import LivemeetingAnalytics from 'components/LiveMeetingAnalytics';
import { useSelector, useDispatch } from 'react-redux';
import CombinedVideoButtonLivemeeting from 'components/CombinedVideoButtonLivemeeting';
import {
  SET_LOCAL_AUDIO,
  SET_LOCAL_VIDEO,
  SET_BACKGROUND_FILTER,
} from 'store/WaitingRoom/waitingRoomAction';
// import { GET_PARTICIPANTS_LIST } from 'store/ParticipantsList/participantsListAction';
import { SET_RAISE_HAND } from 'store/VideoRoom/videoRoomAction';
import axios from 'axios';

export default function ToolBar({
  room,
  connected,
  cameraPublishing,
  isScreenSharing,
  startScreenSharing,
  stopScreenSharing,
  participants,
  localParticipant,
  audioPublishing,
  open,
  setOpen,
  layoutSignal,
  participantId,
}) {
  const params = useParams();
  const theme = useTheme();
  const { push } = useHistory();
  const dispatch = useDispatch();
  const [areAllMuted, setAllMuted] = useState(false);
  const classes = styles();
  const isMobileWidth = useMediaQuery(theme.breakpoints.down('xs'));
  const state = useSelector((state) => state);
  let filterName = '';
  let filterPayload = '';
  const location = useLocation();
  const playpageURl = `/SubscriberPage/${params.pid}/${params.userid}/${params.username}/viewer`;

  const handleMuteAll = () => {
    if (!areAllMuted) {
      participants.map((participant) => participant.camera.disableAudio());

      setAllMuted(true);
    } else {
      participants.map((participant) => participant.camera.enableAudio());
      setAllMuted(false);
    }
  };

  const handleRaiseHand = () => {
    UpdateRaiseHand();
    dispatch({
      type: SET_RAISE_HAND,
      payload: !state.videoRoomReducer.raiseHand,
    });
  };

  // const fetchParticipantList = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_API_URL_NET}/Play/GetParticipationList?vId=${params.pid}`
  //     );
  //     dispatch({
  //       type: GET_PARTICIPANTS_LIST,
  //       payload: response.data,
  //     });
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };

  const UpdateRaiseHand = async () => {
    try {
      // const participant = await axios.get(
      //   `${process.env.REACT_APP_API_URL_NET}/Play/GetParticipationbyId?vId=${params.pid}&userid=${params.userid}&id=${participantId}`
      // );
      // if (participant.data) {
      //   let payload = {
      //     ...participant.data,
      //     LeaveTime: null,
      //     RaisedHand: !participant.data.RaisedHand,
      //   };
      //   const updateList = await axios.post(
      //     `${process.env.REACT_APP_API_URL_NET}/Play/UpdateParticipantsList`,
      //     payload
      //   );
      //   dispatch({
      //     type: GET_PARTICIPANTS_LIST,
      //     payload: updateList.data,
      //   });
      //   fetchParticipantList();
      // }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const toggleVideo = () => {
    if (room && room.camera) {
      const { camera } = room;
      const isVideoEnabled = camera.isVideoEnabled();
      if (isVideoEnabled) {
        camera.disableVideo();
        dispatch({ type: SET_LOCAL_VIDEO, payload: false });
        localStorage.setItem('localVideo', false);
      } else {
        camera.enableVideo();
        dispatch({ type: SET_LOCAL_VIDEO, payload: true });
        dispatch({
          type: SET_BACKGROUND_FILTER,
          payload: { filterName, filterPayload },
        });
        localStorage.setItem('localVideo', true);
      }
    }
  };

  const toggleAudio = () => {
    if (room && room.camera) {
      const camera = room.camera;
      const isAudioEnabled = camera.isAudioEnabled();
      if (isAudioEnabled) {
        camera.disableAudio();
        dispatch({ type: SET_LOCAL_AUDIO, payload: false });
        localStorage.setItem('localAudio', false);
      } else {
        camera.enableAudio();
        dispatch({ type: SET_LOCAL_AUDIO, payload: true });
        localStorage.setItem('localAudio', true);
      }
    }
  };

  const getVideoSource = () => {
    if (room && room.camera) {
      return room.camera.getVideoDevice();
    }
  };

  const changeVideoSource = (videoId) => {
    room.camera.setVideoDevice(videoId);
  };
  const changeAudioSource = (audioId) => {
    room.camera.setAudioDevice(audioId);
  };

  const changeAudioOutput = async (audioOutputDeviceId) => {
    await VideoExpress.setAudioOutputDevice(audioOutputDeviceId);
  };

  const getCurrentAudioOutput = async () => {
    try {
      const currentAudioOutput =
        await VideoExpress.getActiveAudioOutputDevice();
      return currentAudioOutput.deviceId;
    } catch (e) {
      return e;
    }
  };

  const getAudioSource = async () => {
    if (room && room.camera) {
      const audioDevice = await room.camera.getAudioDevice();
      return audioDevice.deviceId;
    }
  };

  const endCall = () => {
    if (room) {
      //updateParticipant();
      push(
        `/${params.pid}/${params.userName}/${params.userId}/${room.roomId}/end`
      );
      room.leave();
    }
  };

  useEffect(() => {
    window.addEventListener('message', function (e) {
      const jsonParse = JSON.parse(e.data);
      if (jsonParse.action == 'endlivemeeting') {
        endCall();
      }
    });
  }, []);

  // const updateParticipant = async () => {
  //   try {
  //     const participant = await axios.get(
  //       `${process.env.REACT_APP_API_URL_NET}/Play/GetParticipationbyId?vId=${params.pid}&userid=${params.userid}`
  //     );
  //     if (participant.data) {
  //       let payload = {
  //         ...participant.data,
  //         LeaveTime: new Date().toUTCString(),
  //         IsActive: false,
  //       };
  //       const response = await axios.post(
  //         `${process.env.REACT_APP_API_URL_NET}/Play/UpdateParticipantsList`,
  //         payload
  //       );
  //       //fetchParticipantList();
  //     }
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };

  useEffect(() => {
    dispatch({
      type: SET_LOCAL_AUDIO,
      payload: JSON.parse(localStorage.getItem('localAudio')),
    });
    dispatch({
      type: SET_LOCAL_VIDEO,
      payload: JSON.parse(localStorage.getItem('localVideo')),
    });
    filterName = localStorage.getItem('filterName');
    filterPayload = localStorage.getItem('filterPayload');
    dispatch({
      type: SET_BACKGROUND_FILTER,
      payload: { filterName, filterPayload },
    });
  }, []);

  useEffect(() => {
    if (connected) {
      state.waitingRoomReducer.localAudio
        ? room.camera.enableAudio()
        : room.camera.disableAudio();
      state.waitingRoomReducer.localVideo
        ? room.camera.enableVideo()
        : room.camera.disableVideo();

      const isAudioEnabled =
        room &&
        room.camera &&
        room.camera.isAudioEnabled() &&
        state.waitingRoomReducer.localAudio
          ? true
          : false;
      const isVideoEnabled =
        room &&
        room.camera &&
        room.camera.isVideoEnabled() &&
        state.waitingRoomReducer.localVideo
          ? true
          : false;

      if (!isAudioEnabled) {
        room.camera.disableAudio();
      }
      if (!isVideoEnabled) {
        room.camera.disableVideo();
      }
    }
  }, [
    connected,
    room,
    state.waitingRoomReducer.localAudio,
    state.waitingRoomReducer.localVideo,
  ]);

  return (
    <>
      {isMobileWidth &&
        playpageURl.toString().toLowerCase() !=
          location.pathname.toLowerCase() && (
          <div className={classes.toolbarMobileContainer}>
            <MuteAudioButton
              toggleAudio={toggleAudio}
              hasAudio={state.waitingRoomReducer.localAudio}
              classes={classes}
              changeAudioSource={changeAudioSource}
            />
            <EndCallButton classes={classes} handleEndCall={endCall} />
            <MuteVideoButton
              toggleVideo={toggleVideo}
              hasVideo={state.waitingRoomReducer.localVideo}
              classes={classes}
              changeVideoSource={changeVideoSource}
            />
          </div>
        )}

      {playpageURl.toString().toLowerCase() ==
        location.pathname.toLowerCase() && (
        <div className={classes.toolbarContainer}>
          <ReactionsButton
            reactionHand={handleRaiseHand}
            classes={classes}
            room={room}
          />
          <EndCallButton classes={classes} handleEndCall={endCall} />
          {sessionStorage.getItem('chatEnabled') !== 'False' && (
            <MoreOptionsButton
              open={open}
              setOpen={setOpen}
              classes={classes}
              participants={participants}
              room={room}
              localParticipant={localParticipant}
              pid={params.pid}
            />
          )}
        </div>
      )}

      {!isMobileWidth &&
        !(
          playpageURl.toString().toLowerCase() ==
          location.pathname.toLowerCase()
        ) && (
          <div className={classes.toolbarContainer}>
            <div className={classes.toolbarContainerWrapper}>
              {/* <MuteAudioButton
                toggleAudio={toggleAudio}
                hasAudio={state.waitingRoomReducer.localAudio}
                classes={classes}
                changeAudioSource={changeAudioSource}
                getAudioSource={getAudioSource}
                audioPublishing={audioPublishing}
              /> */}
              <CombinedAudioButtonLivemeeting
                toggleAudio={toggleAudio}
                hasAudio={state.waitingRoomReducer.localAudio}
                classes={classes}
                changeAudioSource={changeAudioSource}
                getAudioSource={getAudioSource}
                audioPublishing={audioPublishing}
                changeAudioOutput={changeAudioOutput}
                getCurrentAudioOutput={getCurrentAudioOutput}
              />

              <CombinedVideoButtonLivemeeting
                toggleVideo={toggleVideo}
                hasVideo={state.waitingRoomReducer.localVideo}
                classes={classes}
                getVideoSource={getVideoSource}
                cameraPublishing={cameraPublishing}
                changeVideoSource={changeVideoSource}
                room={room}
              />
              {/* {VideoExpress.hasMediaProcessorSupport() && (
                <VideoFilterButton classes={classes} room={room} />
              )} */}
              {/* <SpeakerButton
          cameraPublishing={cameraPublishing}
          changeAudioOutput={changeAudioOutput}
          getCurrentAudioOutput={getCurrentAudioOutput}
          classes={classes}
        /> */}
              {/* <SpeakerSelector
                room={room}
                changeAudioOutput={changeAudioOutput}
                getCurrentAudioOutput={getCurrentAudioOutput}
                classes={classes}
              /> */}

              <RecordingButton room={room} classes={classes} />
              <ScreenSharingButton
                isScreenSharing={isScreenSharing}
                startScreenSharing={startScreenSharing}
                stopScreenSharing={stopScreenSharing}
                classes={classes}
              />
              <MuteAll
                handleMuteAll={handleMuteAll}
                areAllMuted={areAllMuted}
                classes={classes}
              />
              <ReactionsButton
                reactionHand={handleRaiseHand}
                classes={classes}
                room={room}
              />
              <LayoutButton
                classes={classes}
                room={room}
                layoutSignal={layoutSignal}
              />
              <LivemeetingAnalytics classes={classes} room={room} />
              <EndCallButton classes={classes} handleEndCall={endCall} />
            </div>
            <MoreOptionsButton
              open={open}
              setOpen={setOpen}
              classes={classes}
              participants={participants}
              room={room}
              localParticipant={localParticipant}
            />
          </div>
        )}
    </>
  );
}
